import { SOURCE, Source } from "@/constants";

export const formatSocialMediaUser = (name: string) => `@${name}`;

export const EXTERNAL_LINK_COPY_MAP = {
  // CONTINUE WATCHING
  [SOURCE.TIKTOK]: L.MENTIONS_EXTERNAL_LINK_WATCH,
  [SOURCE.YOUTUBE]: L.MENTIONS_EXTERNAL_LINK_WATCH,
  [SOURCE.YOUTUBE_SHORTS]: L.MENTIONS_EXTERNAL_LINK_WATCH,
  [SOURCE.TV]: L.MENTIONS_EXTERNAL_LINK_WATCH,
  [SOURCE.WEB_TV]: L.MENTIONS_EXTERNAL_LINK_WATCH,
  [SOURCE.MANUAL]: L.MENTIONS_EXTERNAL_LINK_WATCH,
  // CONTINUE LISTENING
  [SOURCE.PODCAST]: L.MENTIONS_EXTERNAL_LINK_LISTEN,
  [SOURCE.RADIO]: L.MENTIONS_EXTERNAL_LINK_LISTEN,
  // VIEW
  [SOURCE.FACEBOOK]: L.MENTIONS_EXTERNAL_LINK_SHOW,
  [SOURCE.TWITTER]: L.MENTIONS_EXTERNAL_LINK_SHOW,
  [SOURCE.INSTAGRAM]: L.MENTIONS_EXTERNAL_LINK_SHOW,
  [SOURCE.LINKEDIN]: L.MENTIONS_EXTERNAL_LINK_SHOW,
  // READ
  [SOURCE.NEWS]: L.MENTIONS_EXTERNAL_LINK_READ,
  // UNKNOWN
  UNKNOWN: L.MENTIONS_EXTERNAL_LINK_SHOW,
};

// Specific sources where we don't show the url
export const SOURCE_SHORT_NAME: Partial<Source>[] = [
  SOURCE.TIKTOK,
  SOURCE.INSTAGRAM,
  SOURCE.YOUTUBE,
  SOURCE.TWITTER,
  SOURCE.FACEBOOK,
];
